import {
  useManagementSearchUnitTaskGroups,
  useManagementSearchUnitTaskGroupsCount
} from '@apps-common/apis/management/unit-task/task-groups'
import { TaskHeader } from '@apps-common/apps/portal/pages/units/pages/program-tasks/components'
import { buildTableKeys } from '@apps-common/apps/portal/pages/units/pages/program-tasks/components/tasks-table'
import { useTaskGroupUpdates } from '@apps-common/apps/portal/pages/units/pages/program-tasks/hooks'
import { Table } from '@apps-common/components/elements/table'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { PageClearFilterButton, PageResultsCount } from '@apps-common/components/page'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { usePortalFirebaseUser } from '@apps-common/hooks/usePortalFirebaseUser'
import { useUnitTaskGroupsFilterStore } from '@apps-common/stores/useUnitTaskGroupsFilterStore'

const containerId = 'tasks-group-table-container'

export const TasksTableView = () => {
  const user = usePortalFirebaseUser()
  const navigation = useNavigation()
  const filter = useUnitTaskGroupsFilterStore()

  const {
    isLoading: countIsLoading,
    isError: countIsError,
    data: countData
  } = useManagementSearchUnitTaskGroupsCount({
    model: filter
  })

  const {
    isLoading: tasksLoading,
    isFetching: tasksFetching,
    isRefetching: tasksRefetching,
    isError: tasksError,
    data: tasks,
    refetch: tasksRefetch
  } = useManagementSearchUnitTaskGroups({
    model: filter
  })

  const allLoading = tasksLoading || tasksFetching || tasksError || countIsLoading || countIsError

  useTaskGroupUpdates(containerId, tasksLoading, allLoading, tasks || [])

  const countLoading = countIsLoading || countIsError
  const loading = (tasksLoading || tasksFetching || tasksError || countLoading) && !tasksRefetching

  return (
    <>
      <TaskHeader>
        <div className='flex items-center justify-between'>
          <PageResultsCount loading={countLoading} count={countData} extraText={filter.status?.replaceAll('_', ' ')} />
          <PageClearFilterButton filter={filter} filterKeyWordsFunc={filter.getFilteredByKeywords} callback={filter.clear} />
        </div>
      </TaskHeader>
      <LayoutContainer id={containerId}>
        <LayoutPadding topPadding='pt-[20px]'>
          <div className='w-full'>
            <Table
              loading={loading}
              loadingSkeletonHeight='!leading-[36px]'
              placeholderSkeletonHeight='!leading-[36px]'
              pagination={{
                loading: countLoading,
                count: countData?.resultCount,
                skip: filter.skip,
                take: filter.take,
                onSkipChanged: (value) => filter.setSkip(value),
                onTakeChanged: (value) => filter.setTake(value)
              }}
              keysId={`${filter.status}-${user?.isMonitoringCentre}`}
              keys={buildTableKeys(navigation, filter)}
              data={tasks}
              onSkipChanged={(value) => filter.setSkip(value)}
              onTakeChanged={(value) => filter.setTake(value)}
            />
          </div>
        </LayoutPadding>
      </LayoutContainer>
    </>
  )
}
